module.exports = __webpack_public_path__ + "img/levels-of-detail.en.4f4d24e6.png";